import {call, put, takeLatest} from 'redux-saga/effects';
import searchApi from '../api/search.api';
import * as ActionTypes from '../actions/types.action';
import {processedGQLSearchResults} from '../helpers/data.helper';
import {RELATED_STRATEGY_NONE} from '../constants/constants';

/**
 * Fetches the related-products strip for a finished page-0 search. Requested by search.saga.js
 * with the variables already built (buildRelatedProductsRequest), so this saga knows nothing about
 * the search itself.
 *
 * takeLatest: a new search requests a new strip, and the previous request is cancelled rather than
 * left to land on the wrong page.
 */
function* fetchRelatedProducts(action) {
  try {
    const result = yield call(
      searchApi.relatedProducts,
      action.request,
      action.headers
    );
    const related = result && result.data && result.data.relatedProducts;
    if (!related || (result && result.errors)) {
      yield put({
        type: ActionTypes.GET_RELATED_PRODUCTS_FAILED,
        message: result && result.errors && result.errors[0],
      });
      return;
    }
    const isEmpty =
      related.strategy === RELATED_STRATEGY_NONE ||
      !related.results ||
      related.results.length === 0;
    yield put({
      type: ActionTypes.GET_RELATED_PRODUCTS_SUCCESS,
      parentSearchId: action.request.parentSearchId,
      searchId: related.searchId,
      strategy: related.strategy,
      title: related.title,
      searchedFor: related.searchedFor,
      results: isEmpty
        ? []
        : processedGQLSearchResults(related.results, related.searchId),
    });
  } catch (error) {
    yield put({type: ActionTypes.GET_RELATED_PRODUCTS_FAILED, error});
  }
}

export default function* relatedProducts() {
  yield takeLatest(
    ActionTypes.GET_RELATED_PRODUCTS_REQUESTED,
    fetchRelatedProducts
  );
}
